import { render } from "./ToolbarIcons.vue?vue&type=template&id=3b8960a8&scoped=true"
import script from "./ToolbarIcons.vue?vue&type=script&lang=js"
export * from "./ToolbarIcons.vue?vue&type=script&lang=js"

import "./ToolbarIcons.vue?vue&type=style&index=0&id=3b8960a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8960a8"]])

export default __exports__